/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1SerievideoIdMutationResponse,
  DeleteApiV1SerievideoIdPathParams,
  DeleteApiV1SerievideoIdQueryParams,
  DeleteApiV1SerievideoId401,
  DeleteApiV1SerievideoId404,
  DeleteApiV1SerievideoId500,
} from "../../types/serieVideoRegistroController/DeleteApiV1SerievideoId.ts";

function getDeleteApiV1SerievideoIdUrl(
  id: DeleteApiV1SerievideoIdPathParams["id"],
) {
  const res = { method: "DELETE", url: `/api/v1/serievideo/${id}` as const };
  return res;
}

/**
 * @description Exclusão física do vídeo, suas traduções e visualizações. **(Requer Authorization para autenticação)**
 * @summary Excluir vídeo (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/:id}
 */
export async function deleteApiV1SerievideoId(
  id: DeleteApiV1SerievideoIdPathParams["id"],
  params?: DeleteApiV1SerievideoIdQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiV1SerievideoIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SerievideoId401
      | DeleteApiV1SerievideoId404
      | DeleteApiV1SerievideoId500
    >,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiV1SerievideoIdUrl(id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
